import { Stack, Typography, Divider } from "@mui/material";
import { Product } from "../../../../interfaces/DTO/mislaka_xml_models";
import InsuranceFeesDisplay from "./InsuranceFeesDisplay";
import { formatInsuranceType } from "../../../../utils/pensionEnumFormatter";

interface Props {
  product: Product;
}

const ProductInsuranceCostsSummary: React.FC<Props> = ({ product }) => {
  const coverages = product.policies_or_accounts
    .flatMap(p => p.insurence_coverages || []);
 if (coverages.length === 0) return null;
  return (
    <Stack spacing={4}>
      {coverages.map((coverage, index) => (
        <div key={index}>
          <Typography variant="h6" gutterBottom>
            {coverage.coverage_name}
          </Typography>
            {coverage.coverage_details?.insurance_kind && (
          <Typography variant="body2">
            סוג כיסוי: {formatInsuranceType(coverage.coverage_details.insurance_kind) ?? "לא זמין"}
          </Typography>
            )}
          {coverage.coverage_details?.insurance_fees && (
            <InsuranceFeesDisplay fees={coverage.coverage_details.insurance_fees} />
          )}
          <Divider sx={{ mt: 2 }} />
        </div>
      ))}
    </Stack>
  );
};

export default ProductInsuranceCostsSummary;
